<div class="font-semibold w-full flex items-center gap-2 text-3xl" translate>
  <button
    app-button
    type="button"
    class="lg:hidden rounded-full! flex p-2.5! transition duration-300 border border-solid border-base-gray-light-500 text-theme-500 bg-white hover:bg-base-status-info! hover:text-white! shadow!"
    (click)="onOpenFilter()"
  >
    <svg-icon [src]="'icon-filter2' | icon" class="flex items-center justify-center w-7 h-7"></svg-icon>
  </button>
  <ng-content></ng-content>
</div>
